import Grid from "@mui/material/Grid2";
import Typography from "@mui/material/Typography";
import { BoxSpaceCenter } from '../style/box';
import { TypographyNomalBold } from '../style/typography';
import { RequestButton } from "../style/button";
import { Table, TableBody, TableContainer, TableHead, TableRow } from '@mui/material';
import { SmallCell, LargeCell } from "../style/tablecell";

export const Complete = ({ iconComponent: IconComponent, color, mainMessage, workData, subMessage, onClick, disabled, buttonName }) => {
  return (
    <Grid size={{ xs: 12 }}>
      <BoxSpaceCenter sx={{ flexDirection: 'column', textAlign: 'center' }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <IconComponent sx={{ fontSize: { xs: "6rem", sm: "7rem", md: "8rem" }, color }} />
            <TypographyNomalBold sx={{ mt: 2, fontSize: { xs: "1.3rem", sm: "1.5rem", md: "2rem" }, textAlign: 'center' }}>
              {mainMessage}
            </TypographyNomalBold>
            {workData && (
              <BoxSpaceCenter sx={{ mt: 4 }}>
                <TableContainer sx={{ mt: 4, maxWidth: 600, margin: '0 auto' }}>
                  <Table sx={{
                    tableLayout: "auto",
                    minWidth: "100%",
                    '& thead th': {
                      borderTop: '1px solid rgba(0,0,0,0.12)'
                    }
                  }}>
                    <TableHead>
                      <TableRow>
                        <SmallCell sx={{ fontWeight: 'bold' }}>
                          業務内容
                        </SmallCell>
                        <LargeCell sx={{ whiteSpace: 'pre-line' }}>
                          {workData.map((work) => work.work_name).join('\n')}
                        </LargeCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <SmallCell sx={{ fontWeight: 'bold' }}>
                          コメント
                        </SmallCell>
                        <LargeCell sx={{ whiteSpace: 'pre-line' }}>
                          {workData[0].comment}
                        </LargeCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </BoxSpaceCenter>
            )}
            <Typography sx={{ mt: 4, fontSize: { xs: "0.75rem", md: "1rem" }, textAlign: 'center', whiteSpace: 'pre-line' }}>
              {subMessage}
            </Typography>
          </Grid>
        </Grid>
      </BoxSpaceCenter>
      {onClick && buttonName && disabled !== undefined && (
        <BoxSpaceCenter sx={{ mt: 4 }}>
          <RequestButton
            onClick={onClick}
            disabled={disabled}
            sx={{
              width: { xs: '65%', sm: '50%', md: '40%' },
              maxWidth: '300px'
            }}
          >
            {buttonName}
          </RequestButton>
        </BoxSpaceCenter>
      )}
    </Grid>
  );
};